import React from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import type { ITheme } from '@homeviews/styles'
import { WindowTitle } from '@homeviews/shared-ui'
import { WidgetBuilder } from '@homeviews/widgets'

const useStyles = makeStyles((theme: ITheme) =>
  createStyles({
    root: {
      padding: theme.spacing(
        theme.layout.contentHorizontalPadding,
        theme.layout.contentVerticalPadding,
      ),
    },
  }),
)

const Widgets: React.FC = () => {
  const classes = useStyles()

  return (
    <>
      <WindowTitle title="Create Widget" />
      <div className={classes.root}>
        <WidgetBuilder />
      </div>
    </>
  )
}

export default Widgets
